<!-- eslint-disable vue/html-self-closing -->
<template>
  <section class="link-merge-request-form">
    <div class="link-merge-request-form__content">
      <div class="content">
        <div
          class="form"
          v-if="hasAvailableProjects"
        >
          <custom-select
            v-if="sourceProjectForks && sourceProjectForks.items?.length > 0"
            v-model="form.sourceProject"
            :options="sourceProjectForks.items"
            :is-fork-selector="true"
          >
            <template slot-scope="{ option }">{{ option.ownerAlias }}/{{ option.alias }}</template>
          </custom-select>
          <small
            class="text-danger"
            v-if="formValidationErrors?.sourceProjectUuid"
          >
            {{ formValidationErrors.sourceProjectUuid }}
          </small>
        </div>
        <div
          class="form --none"
          v-else
        >
          <span>Нет доступных проектов</span>
          <gf-link-button
            :href="`/project/${alias}/${projectAlias}/create-fork`"
            text="Создать форк"
            variant="primary"
            before-icon="gf-icon-git-branch"
          ></gf-link-button>
        </div>
        <div
          class="form"
          v-if="hasAvailableProjects"
        >
          <project-branch-selector
            :alias="form.sourceProject?.ownerAlias || alias"
            :project-model="form.sourceProject?.alias || projectAlias"
            :placeholder="$t('message.source_branch')"
            :disabled="form.isNewBranch"
            :selected="form.isNewBranch ? form.sourceBranchName : null"
            @input="setSourceBranchValue"
            :error="formValidationErrors?.sourceBranchName"
          />
          <small
            class="text-danger"
            v-if="formValidationErrors?.sourceBranchName"
          >
            {{ formValidationErrors.sourceBranchName }}
          </small>
        </div>
        <div
          class="new-branch"
          v-if="hasAvailableProjects"
        >
          <label class="gf-custom-checkbox">
            <input
              v-model="form.isNewBranch"
              type="checkbox"
              name="uploadFilesCommitRadio"
            />
            <div class="w-100">
              <div class="w-100">
                {{ $t('message.create_new_branch_from_standart') }}
                <br />
                <label
                  v-if="form.isNewBranch"
                  class="gf-counted-input"
                  for="newSourceBranchName"
                  :data-current-length="form.newSourceBranchName?.length + ' / 250'"
                >
                  <input
                    v-model="form.newSourceBranchName"
                    id="newSourceBranchName"
                    type="text"
                    minlength="1"
                    maxlength="250"
                    class="form-control form-control-sm w-100 mt-2"
                    :class="{
                      'border-danger': formValidationErrors?.newSourceBranchName?.length > 0
                    }"
                    :placeholder="$t('message.new_branch_name')"
                  />
                </label>
                <div v-if="typeof formValidationErrors?.newSourceBranchName === 'object'">
                  <div
                    v-for="(error, index) in formValidationErrors?.newSourceBranchName"
                    :key="index"
                    class="text-danger"
                  >
                    <small>{{ error }}</small>
                  </div>
                </div>
                <div
                  v-else-if="
                    formValidationErrors?.newSourceBranchName &&
                    typeof formValidationErrors?.newSourceBranchName === 'string'
                  "
                  class="text-danger"
                >
                  <small>{{ formValidationErrors?.newSourceBranchName }}</small>
                </div>
              </div>
            </div>
          </label>
        </div>
      </div>
      <div
        class="link-merge-request-form__actions"
        v-if="hasAvailableProjects"
      >
        <gf-button
          variant="outline-secondary"
          :text="$t('message.cancel')"
          @click="onCancelClick"
        ></gf-button>
        <gf-button
          variant="success"
          :text="$t('message.link')"
          @click="onLinkMergeRequestClick"
        ></gf-button>
      </div>
    </div>
  </section>
</template>

<script>
import GfButton from '@/shared-modules/shared-components/shared/components/GfButton';
import CustomSelect from '@shared/shared-components/shared/custom-select';
import RefS from '@shared/services/reference.service';
import ProjectBranchSelector from '@/shared-modules/shared-components/shared/project-branch-selector';
import { FORM_NAME_ENUMS } from '@/shared-modules/variables/form-name.enums';
import GfLinkButton from '@/shared-modules/shared-components/shared/components/GfLinkButton';

export default {
  name: 'LinkMergeRequestForm',
  components: { GfButton, CustomSelect, ProjectBranchSelector, GfLinkButton },
  data() {
    return {
      form: {
        sourceBranchName: '',
        newSourceBranchName: '',
        sourceProject: null,
        isNewBranch: false
      },
      defaultSourceProject: null
    };
  },
  computed: {
    alias() {
      return this.$route.params?.alias;
    },
    projectAlias() {
      return this.$route.params?.projectAlias;
    },
    sourceProjectForks() {
      return this.$store.getters.getRefSourceProjectForks || [];
    },
    formValidationErrors() {
      return this.$store.getters.getFormErrors(FORM_NAME_ENUMS.LINKED_MERGE_REQUEST_FORM);
    },
    hasAvailableProjects() {
      return this.sourceProjectForks?.items?.length > 0;
    },
    projectUuid() {
      return this.$store.getters.getProjectUuid;
    }
  },
  mounted() {
    this.getProjectForks();
  },
  methods: {
    getProjectForks() {
      if (!this.sourceProjectForks?.items) {
        RefS.getSourceProjectForks(this.alias, this.projectAlias).then((res) => {
          const foundProject = res.items.find((item) => item.alias === this.projectAlias);
          if (foundProject) {
            this.defaultSourceProject = foundProject;
            this.form.sourceProject = foundProject;
          } else {
            this.form.sourceProject = this.sourceProjectForks?.items[0];
            this.defaultSourceProject = { id: this.projectUuid };
          }
        });
      } else {
        this.form.sourceProject = this.sourceProjectForks?.items.find((item) => item.alias === this.projectAlias);
      }
    },
    setSourceBranchValue(e) {
      this.form.sourceBranchName = e.title;
    },
    onLinkMergeRequestClick() {
      this.$emit('submit', {
        sourceProjectUuid: this.form.sourceProject?.id,
        targetProjectUuid: this.defaultSourceProject?.id ? this.defaultSourceProject?.id : this.projectUuid,
        sourceBranchName: this.form.isNewBranch ? null : this.form.sourceBranchName,
        newSourceBranchName: this.form.isNewBranch ? this.form.newSourceBranchName : null
      });
    },
    resetSelectedValues() {
      this.form = {
        sourceBranchName: '',
        newSourceBranchName: '',
        sourceProject: null,
        targetProject: null,
        isNewBranch: false
      };
      this.form.sourceProject = this.defaultSourceProject;
    },
    onCancelClick() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss">
$this: '.link-merge-request-form';

#{$this} {
  #{$this}__content {
    display: flex;
    flex-direction: column;
    gap: 16px;

    & > .content {
      display: flex;
      flex-direction: column;
      gap: 12px;

      & > .form.--none {
        padding: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: var(--primary);
        border: 1px solid var(--primary);
        border-radius: 6px;
        background-color: color-mix(in srgb, var(--primary) 10%, var(--white));
        gap: 6px;
      }

      & > .new-branch {
        display: flex;
        flex-direction: column;
        gap: 8px;

        & > label {
          margin-bottom: 0;
        }
      }
    }

    #{$this}__actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 8px;
    }
  }
}
</style>
